import React, { useState } from "react";
import { Layout, Menu } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import "./style.css";
import routes from "../Routes/routes";

const { Sider } = Layout;

const Sidebar = ({
  collapsed,
  setCollapsed,
  mobileOpen,
  setMobileOpen,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [showDashboardPopup, setShowDashboardPopup] =
    useState(false);
  const [hoverTimeout, setHoverTimeout] =
    useState(null);

  const { data } = useSelector(
    (state) => state.selectedDataRecord
  );

  const dashboardsFromApi = Array.isArray(data)
    ? data
    : Array.isArray(data?.items)
    ? data.items
    : [];

  const dashboards = [
    ...dashboardsFromApi,
    {
      eda_name: "Cash Flow",
      url: "https://uatkeibiaivayona.inteliquantai.com/cashflow/",
    },
    // {
    //   eda_name: "Cash In",
    //   url: "https://uatkeibiaivayona.inteliquantai.com/cashIn/",
    // },
  ];

  const handlePopupOpen = () => {
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
    }

    setShowDashboardPopup(true);
  };

  const handlePopupClose = () => {
    const timeout = setTimeout(() => {
      setShowDashboardPopup(false);
    }, 300);

    setHoverTimeout(timeout);
  };

 const menuItems = routes
  .filter((route) => !route.hidden)
  .map((route) => {
    // Routes without children
    if (!route.children) {
      return {
        key: route.path,
        label: (
          <Link to={route.path}>
            {route.label}
          </Link>
        ),
      };
    }
 
    // Routes with children
    return {
      key: route.path,
      label: route.label,
      children: route.children
        ?.filter((child) => !child.hidden)
        ?.map((child) => {
          const isFinancialDashboard =
            child.label ===
            "Financial Insights Dashboards";
 
          return {
            key: `${route.path}/${child.path}`,
            label: (
              <div
                onMouseEnter={() => {
                  if (isFinancialDashboard) {
                    handlePopupOpen();
                  }
                }}
                onMouseLeave={() => {
                  if (isFinancialDashboard) {
                    handlePopupClose();
                  }
                }}
              >
                <Link
                  to={`${route.path}/${child.path}`}
                >
                  {child.label}
                </Link>
              </div>
            ),
          };
        }),
    };
  });

  const handleDashboardClick = (dashboard) => {
    setShowDashboardPopup(false);

    if (dashboard.url) {
      window.open(dashboard.url, "_blank");
      return;
    }
//  if (dashboard.eda === "EDA3_CashIn") {
//     navigate("/Insights/eda-CashIndashboard-detail", {
//       state: {
//         selectedProcess: dashboard.selectedProcess,
//         category: dashboard.category,
//         dashboard,
//       },
//     });
//     return;
//   }
   
    const dashboardName = dashboard?.eda_name?.toLowerCase?.() || "";
  const dashboardNumber = dashboard?.eda_no?.toLowerCase?.() || "";

  // Fixed Cost
  if (
    dashboardName.includes("fixedcost1") ||
    dashboardNumber.includes("fixedcost1")
  ) {
     navigate("/Insights/eda-dashboard-detail", {
      state: {
        selectedProcess: "generalAccRep",
        category: "EDA",
        dashboard,
      },
    });
    return;
  }
  };

  return (
    <>
      {/* Desktop Sidebar */}
      <Sider
        collapsible
        collapsed={collapsed}
        trigger={null}
        width={240}
        collapsedWidth={80}
        className="hidden lg:block fixed top-14 left-0 h-[calc(100vh-64px)] custom-sidebar"
      >
        <div className="h-full overflow-y-auto sidebar-scroll">
          <Menu
            mode="inline"
            selectedKeys={[location.pathname]}
            items={menuItems}
            className="sidebar-menu"
          />
        </div>

        {showDashboardPopup && (
  <div
    onMouseEnter={handlePopupOpen}
    onMouseLeave={handlePopupClose}
    style={{
      position: "fixed",
      left: collapsed ? "85px" : "245px",
      top: "120px",
      width: "350px",
      background: "rgba(255,255,255,0.98)",
      backdropFilter: "blur(12px)",
      borderRadius: "20px",
      overflow: "hidden",
   
      border: "1px solid rgba(255,255,255,0.3)",
      zIndex: 9999,
      animation: "popupFade 0.25s ease",
    }}
  >
    {/* Header */}
    <div
      style={{
       background:
  "linear-gradient(90deg, #3eafd8, #8eb5ff, #9ef0f7)",
        padding: "18px 20px",
        color: "#fff",
      }}
    >
      <div
        style={{
          fontSize: "18px",
          fontWeight: "700",
        }}
      >
        Financial Dashboards
      </div>

      <div
        style={{
          fontSize: "12px",
          opacity: 0.9,
          marginTop: "4px",
        }}
      >
        Select a dashboard to open
      </div>
    </div>

    {/* Dashboard List */}
    <div
      style={{
        maxHeight: "420px",
        overflowY: "auto",
        padding: "12px",
      }}
    >
      {dashboards.length > 0 ? (
        dashboards.map((dashboard, index) => (
          <div
            key={index}
            onClick={() =>
              handleDashboardClick(dashboard)
            }
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "14px 16px",
              marginBottom: "10px",
              borderRadius: "14px",
              cursor: "pointer",
              background: "#f8faff",
              border: "1px solid #edf1ff",
              transition: "all .25s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background =
                "linear-gradient(90deg,#eef3ff,#f8f1ff)";
              e.currentTarget.style.transform =
                "translateX(5px)";
              e.currentTarget.style.boxShadow =
                "0 6px 20px rgba(69,101,216,.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background =
                "#f8faff";
              e.currentTarget.style.transform =
                "translateX(0px)";
              e.currentTarget.style.boxShadow =
                "none";
            }}
          >
            <div>
              <div
                style={{
                  fontWeight: 600,
                  color: "#253858",
                }}
              >
                {dashboard?.eda_name}
              </div>

              <div
                style={{
                  fontSize: "12px",
                  color: "#6b7280",
                  marginTop: "4px",
                }}
              >
                Analytics Dashboard
              </div>
            </div>

            <div
              style={{
                width: "34px",
                height: "34px",
                borderRadius: "50%",
                background:
                  "linear-gradient(135deg,#4c1588,#4565d8)",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "16px",
              }}
            >
              →
            </div>
          </div>
        ))
      ) : (
        <div
          style={{
            textAlign: "center",
            padding: "30px",
            color: "#888",
          }}
        >
          No dashboards found
        </div>
      )}
    </div>
  </div>
)}
      </Sider>

      {/* Mobile Sidebar */}
      {mobileOpen && (
        <div className="fixed inset-0 z-50 flex lg:hidden">
          <div className="w-64 bg-gradient-to-b from-cyan-400 to-indigo-900 text-white shadow-lg">
            <div className="h-16 flex items-center justify-center font-bold text-lg">
              Vyona Energy
            </div>

            <Menu
              mode="inline"
              selectedKeys={[location.pathname]}
              items={menuItems}
              className="sidebar-menu"
              onClick={() =>
                setMobileOpen(false)
              }
            />
          </div>

          <div
            className="flex-1 bg-black bg-opacity-40"
            onClick={() =>
              setMobileOpen(false)
            }
          />
        </div>
      )}
    </>
  );
};

export default Sidebar;